var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSales(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3508_2836)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0692 18.5271L12.6832 16.0625L7.295 23.4652L10.681 25.9298L16.0692 18.5271Z",
    stroke: "#85C11F",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5078 25.9255L40.8938 23.4609L35.5056 16.0583L32.1196 18.5229L37.5078 25.9255Z",
    stroke: "#85C11F",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.072 25.0508L13.926 26.4308",
    stroke: "#85C11F",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.144 31.4805L25.368 32.5305C25.956 33.0405 26.016 33.9345 25.506 34.5225C24.996 35.1105 24.102 35.1705 23.514 34.6605L22.938 34.1625",
    stroke: "#85C11F",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.78 23.5742L32.712 27.8102C33.3 28.3202 33.36 29.2142 32.85 29.8022C32.34 30.3902 31.446 30.4502 30.858 29.9402L28.008 27.2942",
    stroke: "#85C11F",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.002 27.293L30.168 29.297C30.756 29.807 30.816 30.701 30.306 31.289C29.796 31.877 28.902 31.937 28.314 31.427L26.004 29.351",
    stroke: "#85C11F",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.004 29.3516L27.63 30.7736C28.218 31.2836 28.278 32.1776 27.768 32.7656C27.258 33.3536 26.364 33.4136 25.776 32.9036L24.15 31.4816",
    stroke: "#85C11F",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4 18.9107L29.616 19.6607L24.402 18.8867L16.512 19.9067C17.88 21.3347 19.176 22.1207 21.138 21.8687L22.122 21.7427C22.308 23.1707 23.724 23.9267 25.152 23.7407L27.78 23.5727",
    stroke: "#85C11F",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.712 27.8031L37.104 25.1211",
    stroke: "#85C11F",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6716 28.3733C17.1558 27.7593 17.0506 26.8689 16.4366 26.3846C15.8225 25.9004 14.9321 26.0056 14.4479 26.6197L13.5636 27.7409C13.0794 28.355 13.1846 29.2454 13.7986 29.7296C14.4127 30.2139 15.3031 30.1087 15.7873 29.4946L16.6716 28.3733Z",
    stroke: "#85C11F",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8945 30.135C19.3787 29.521 19.2735 28.6306 18.6595 28.1464C18.0454 27.6621 17.155 27.7673 16.6708 28.3814L15.7865 29.5027C15.3023 30.1167 15.4075 31.0071 16.0215 31.4914C16.6356 31.9756 17.526 31.8704 18.0102 31.2563L18.8945 30.135Z",
    stroke: "#85C11F",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1187 31.8811C21.603 31.2671 21.4978 30.3767 20.8837 29.8925C20.2696 29.4082 19.3793 29.5134 18.895 30.1275L18.0108 31.2488C17.5265 31.8628 17.6317 32.7532 18.2458 33.2374C18.8598 33.7217 19.7502 33.6165 20.2345 33.0024L21.1187 31.8811Z",
    stroke: "#85C11F",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4538 34.76C22.9381 34.146 22.8329 33.2556 22.2188 32.7714C21.6047 32.2871 20.7144 32.3923 20.2301 33.0064C19.7458 33.6204 19.8511 34.5108 20.4651 34.9951C21.0792 35.4793 21.9696 35.3741 22.4538 34.76Z",
    stroke: "#85C11F",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.11207 32.5913C1.44607 24.4193 3.39007 14.4833 10.5241 8.33933C19.2241 0.845326 32.3521 1.82333 39.8461 10.5233",
    stroke: "#85C11F",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2661 16.0312C46.6681 24.1192 44.6701 33.8093 37.6621 39.8453C28.9621 47.3392 15.8341 46.3673 8.34009 37.6613",
    stroke: "#85C11F",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3508_2836"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.186,
    height: 42.186,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSales);
export default __webpack_public_path__ + "static/media/icon-sales.6118a1c54564cce529b83e69cf7f1309.svg";
export { ForwardRef as ReactComponent };